import React from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { Image } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import MasterLayout from "@layouts/MasterLayout.react";
import { Div } from "@components/Generics.react";
import { settings } from "@config/settings/app.settings";
import SearchBar from "@components/SearchBar.react";
import { darkStyle, gradient } from "@utilities/helpers";
import RecommendedArticles from "@components/RecommendedArticles.react";

export default function AppHome(props) {
    const user = useSelector((state) => state.auth.user);
    const { t } = useTranslation("common");
    const stages = settings.gamification.stages;
    const showStage = _.keys(stages).length > 1;
    const pageContent = (
        <Div
            basepad
            fullht
            style={{ background: gradient("#dddddd", "to top") }}
        >
            <Div fit-content centered>
                <SearchBar />
            </Div>
            <br />
            {showStage && (
                <Div
                    topRounded
                    relaxed
                    charcoal
                    large
                    wd="240px"
                    centered
                    center-align
                    uppercase
                    style={darkStyle("#666666", "to top")}
                >
                    {`${t("home.stage")} ${stages[user.stage]}`}
                </Div>
            )}
            <Div relative fluid style={{ height: "0", paddingBottom: "133%" }}>
                {_.map(
                    settings.home[user.stage || 3].images,
                    ({ src, coords, link }, idx) => {
                        return (
                            <NavLink to={link} key={`homeelm-${idx}`}>
                                <Image
                                    src={src}
                                    style={{
                                        position: "absolute",
                                        left: `${coords[0]}%`,
                                        top: `${coords[1]}%`,
                                        width: `${coords[2]}%`,
                                    }}
                                />
                            </NavLink>
                        );
                    }
                )}
            </Div>
        </Div>
    );
    // ========================= Render Function =================================
    return (
        <MasterLayout
            title={"Welcome"}
            mainPanel={pageContent}
            rightPanelName={t(`rightPanel.recommended`)}
            rightPanel={<RecommendedArticles />}
            rootPage={true}
        />
    );
}
